var React = require('react');

function IconsendInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#a1c842;stroke-linecap:round;stroke-linejoin:round;}")),React.createElement("g",{"transform":"translate(-1.304 -3.5)","key":1},[React.createElement("path",{"className":"a","d":"M4,4H20a2.006,2.006,0,0,1,2,2V18a2.006,2.006,0,0,1-2,2H4a2.006,2.006,0,0,1-2-2V6A2.006,2.006,0,0,1,4,4Z","key":0}),React.createElement("path",{"className":"a","d":"M22,6,12,13,2,6","key":1})])]);
}

IconsendInline.defaultProps = {"width":"21.393","height":"17","viewBox":"0 0 21.393 17"};

module.exports = IconsendInline;

IconsendInline.default = IconsendInline;
